module.exports = __webpack_public_path__ + "static/instrukcja_montazu_hakow_bezpieczenstwa-c91544d85866020ef1b65b77cd6a355e.pdf";